<!-- *ngIf="lighteningDeals" -->
<div class="section-gap pb-0" *ngIf="homePageDataSectionsSilders">
  <div class="container">
    <mat-toolbar
      color="primary"
      style="height: 220px"
      class="section-title-toolbar"
    >
      <mat-toolbar-row>
        <div fxLayoutAlign="space-between" class="w-100 toolbar-title">
          <div class="block-title">
            <h2
              class="text-inverse mb-0 text-xxl"
              i18n="LighteningDeals|LighteningDeals@@LighteningDeals"
            >
              {{ fullData[1].name }}
            </h2>
          </div>
          <a
            [routerLink]="['/' + lang + '/products']"
            [queryParams]="{ list_ids: fullData[1].list_id }"
            class="text-sm text-uppercase"
            i18n="viewAll|viewAll@@viewAllLightingDeals"
          >
            {{ 'home_Page.viewAll' | translate }}</a
          >
        </div>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="shop-card-gap px-4">
      <div fxLayout="row wrap" class="col-gap">
        <!-- *ngFor="let product of lighteningDeals" -->
        <div
          fxFlex.xs="100"
          fxFlex.sm="50"
          fxFlex.md="25"
          fxFlex.lg="25"
          fxFlex.xl="25"
          *ngFor="let product of fullData[1].products; let i = index"
        >
          <embryo-NewProductsCard
            *ngIf="i < 4"
            [product]="product"
            (addToCart)="addToCart($event)"
            [currency]="embryoService.currency"
            (addToWishlist)="addToWishlist($event)"
          ></embryo-NewProductsCard>
        </div>
      </div>
    </div>
  </div>
</div>
